import BaseModelAPI from '../BaseModelAPI';

export default class Status extends BaseModelAPI {
	static entity = 'status';
	static entityName = 'status';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.description = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}